'use strict';

var tabs = document.querySelector('[data-behavior="pdp-ingredients-tabs"]');
var dropdown = document.querySelector('[data-behavior="pdp-ingredients-dropdown"]');

// memoize
var $tabs = $(tabs);
var $dropdown = $(dropdown);

var setDropdownValue = function setDropdownValue(value) {
  return dropdown.value = value;
};

var initTabs = function initTabs() {
  new Foundation.Tabs($tabs);

  // if a tab is visible on load, select it (> mobile size)
  var visibleTab = $tabs.find('.tabs-title:visible:first');
  if (visibleTab.length) {
    $tabs.foundation('_handleTabChange', visibleTab);
  }

  // on tab click, update the dropdown value
  $tabs.on('change.zf.tabs', function (event) {
    var ingredient = $(event.target).find('[aria-selected="true"]').attr('data-ingredient');
    setDropdownValue(ingredient);
  });
};

var initDropdown = function initDropdown() {
  // if an option is visible on load, select it (== mobile size)
  var visibleOption = $dropdown.find('option').filter(function () {
    return $(this).css('display') === 'block';
  }).first();
  var ingredient = visibleOption.attr('data-ingredient');
  var optionTab = $tabs.find('[data-ingredient="' + ingredient + '"]');
  if (visibleOption.length) {
    $tabs.foundation('_handleTabChange', optionTab);
    setDropdownValue(ingredient);
  }

  // on dropdown change, update the tab
  $dropdown.on('change', function () {
    $tabs.foundation('_handleTabChange', $tabs.find('[data-ingredient="' + dropdown.value + '"]'));
  });
};

if (tabs) {
  initTabs();
}
if (dropdown) {
  initDropdown();
}